import { Box, Card, CardContent, Typography } from "@mui/material"
import { useEffect, useRef } from "react"
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { tomorrow, yesterday, lastMonth, nextMonth, lastWeek, nextWeek } from "resources/ParametersTypes";
import moment from "moment";
import 'moment/locale/ca';

const DateNavigation = ({
  children, title, selectedDate, setSelectedDate, minDate, maxDate, interval
}) => {
  const subtract = useRef()
  const add = useRef()
  const displayDate = useRef()

  // ! TODO NEXT: Add functionality to change per week

  const dayFormat = 'DD/MM/YYYY'
  const monthFormat = 'MMMM'

  const chevronStyle = {
    cursor: 'pointer',
    mx: .5,
  }


  useEffect(() => {
    if (interval === 'day') {
      subtract.current = yesterday
      add.current = tomorrow
    }
    else if (interval === 'month') {
      subtract.current = lastMonth
      add.current = nextMonth
    }
    else if (interval === 'week') {
      subtract.current = lastWeek
      add.current = nextWeek
    }
  }, [interval])

  useEffect(() => {
    const selectedDateMomentObject = moment(selectedDate)
    if (interval === 'month') {
      displayDate.current = selectedDateMomentObject.clone().locale('ca').format(monthFormat)
    }
    else {
      displayDate.current = selectedDateMomentObject.clone().locale('ca').format(dayFormat)
    }
  }, [interval, selectedDate])

  const handleSubtractDate = () => {
    const selectedDateMomentObject = moment(selectedDate)

    const minDateGuard = minDate.endOf('day')
    const selectedDateGuard = selectedDateMomentObject.clone().startOf('month')

    if (interval !== 'month' ? selectedDateMomentObject > minDateGuard : selectedDateGuard > minDateGuard) {
      setSelectedDate(subtract.current(selectedDateMomentObject).toISOString())
    }
  }

  const handleAddDate = () => {
    const selectedDateMomentObject = moment(selectedDate)

    const maxDateGuard = maxDate.startOf('day')

    if (selectedDateMomentObject < maxDateGuard) {
      setSelectedDate(add.current(selectedDateMomentObject).toISOString())
    }
  }

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', whiteSpace: 'pre-wrap' }} >
          <Box>
            <Typography variant='subtitle' gutterBottom>
              {title}{' '}
            </Typography>
            <Typography variant='subtitle' gutterBottom sx={{ textTransform: 'capitalize' }} >
              {displayDate.current}
            </Typography>
          </Box>
          <Box>
            <ChevronLeftIcon sx={chevronStyle} onClick={handleSubtractDate} />
            <ChevronRightIcon sx={chevronStyle} onClick={handleAddDate} />
          </Box>
        </Box>
        <Box sx={{ position: "relative", height: "40vh", width: "80vw" }}>
          {children}
        </Box>
      </CardContent>
    </Card>
  )
}

export default DateNavigation